<template>
  <div class="modal-overlay" @click.self="cancel"> 
    <transition name="modal">
      <div class="modal-container" @click.stop>

        <!-- Header -->
        <div class="modal-header">
          <ion-icon name="calendar-outline" class="modal-icon" />
          <div class="modal-title">Seleccionar Rango Personalizado</div>
          <div class="header-divider"></div>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <form @submit.prevent="applyRange">

            <div class="form-group">
              <label for="startDate">Desde</label>
              <input
                id="startDate"
                type="date"
                v-model="startDate"
                :max="maxDate"
              />
            </div>

            <div class="form-group">
              <label for="endDate">Hasta</label>
              <input
                id="endDate"
                type="date"
                v-model="endDate"
                :max="maxDate"
              />
              <span v-if="error" class="error-msg">La fecha final no puede ser anterior a la inicial.</span>
            </div>

            <!-- Botones -->
            <div class="modal-footer">
              <button type="button" class="cancel-btn" @click="cancel">Cancelar</button>
              <button type="submit" class="apply-btn" :disabled="!isValid">Aplicar</button>
            </div>

          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'DateRangePicker',
  props: {
    initialStart: String,
    initialEnd: String
  },
  data() {
    return {
      startDate: '',
      endDate: '',
      maxDate: new Date().toISOString().slice(0, 10),
      error: false
    }
  },
  watch: {
    startDate() {
      this.validate()
    },
    endDate() {
      this.validate()
    }
  },
  mounted() {
    this.startDate = this.initialStart || ''
    this.endDate = this.initialEnd || ''
    this.validate()
  },
  computed: {
    isValid() {
      return this.startDate && this.endDate && !this.error
    }
  },
  methods: {
    validate() {
      if (this.startDate && this.endDate) {
        this.error = this.endDate < this.startDate
      } else {
        this.error = false
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    applyRange() {
      if (this.isValid) {
        this.$emit('apply', {
          startDate: this.startDate,
          endDate: this.endDate
        })
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: 'Manrope', sans-serif;
}

.modal-container {
  background: #ffffff;
  border-radius: 1rem;
  padding: 2rem;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.2s ease-in-out;
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.modal-icon {
  font-size: 1.3rem;
  color: #3b82f6;
}

.modal-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.header-divider {
  flex: 1;
  height: 1.3px;
  background: #e2e8f0;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 1.25rem;
}

label {
  font-size: 0.92rem;
  font-weight: 600;
  color: #334155;
  text-align: left;
}

input[type='date'] {
  padding: 0.6rem 0.9rem;
  border-radius: 0.75rem;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.95rem;
  color: #0f172a;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

input[type='date']:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  outline: none;
}

.error-msg {
  font-size: 0.85rem;
  color: #dc2626;
  font-weight: 500;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

.cancel-btn,
.apply-btn {
  padding: 0.55rem 1.2rem;
  border-radius: 0.6rem;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.cancel-btn {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  color: #1e293b;
}

.cancel-btn:hover {
  background: #e2e8f0;
}

.apply-btn {
  background: #3b82f6;
  color: white;
  border: none;
}

.apply-btn:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
